import React, { FunctionComponent } from 'react';
import { Typography } from '@rbx/ui';
import OasType from '../../../sharedUI/components/OasType';

interface ReturnTitleProps {
  refName: string;
  className?: string;
}

const ReturnTitle: FunctionComponent<React.PropsWithChildren<ReturnTitleProps>> = ({
  refName,
  className,
}) => {
  return (
    <Typography variant='body1' className={className}>
      <OasType refName={refName} />
    </Typography>
  );
};

export default ReturnTitle;
